module.exports = __webpack_public_path__ + "img/logo.71f396e.png";